import type { TFunction } from 'i18next';
import { Observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Creative } from '@feathr/blackbox';
import { type IColumn, TableColumnHeader } from '@feathr/components';

function creativeSummaryColumn(t: TFunction): Array<IColumn<Creative>> {
  return [
    {
      accessor: 'name',
      Header: TableColumnHeader({
        title: t('File Name'),
      }),
      width: 300,
      Cell({ original }): JSX.Element {
        return (
          <Observer>
            {function useAnonymousFunction(): JSX.Element {
              return <span>{original.name}</span>;
            }}
          </Observer>
        );
      },
    },
    {
      id: 'dimensions',
      Header: TableColumnHeader({
        title: t('Dimensions'),
      }),
      Cell({ original }): JSX.Element {
        return (
          <Observer>
            {function useAnonymousFunction(): JSX.Element {
              return <span>{`${original.get('width')}px x ${original.get('height')}px`}</span>;
            }}
          </Observer>
        );
      },
    },
    {
      id: 'type',
      Header: TableColumnHeader({
        title: t('Type'),
      }),
      Cell({ original }): JSX.Element {
        return (
          <Observer>
            {function useAnonymousFunction(): JSX.Element {
              const type = original.getSpec();
              return <span>{type ? type.name : t('Unknown')}</span>;
            }}
          </Observer>
        );
      },
    },
  ];
}

export default creativeSummaryColumn;
